<div class="footer-text">
  © 2025 Copyright, <b style="color:#1E293B">LinkageIT</b><sup>®</sup>
</div>
